// Feature flags — ship-dark switches for finished features that are not yet
// announced. The code stays in place; only the entry points are hidden.
// Flip a flag to true to bring every entry point back at once.

// Sözleşme Şablon Kütüphanesi (Template Library): sidebar items, dashboard
// quick action, admin tab, contract-form browse button, and the page route.
export const TEMPLATE_LIBRARY_ENABLED = false;
